import { OrderedSet } from "immutable";
import { createAction, handleActions } from "redux-actions";
import { CALL_API } from "constants/api";

const SET_FILTER = "SET_FILTER";
const ADD_SHARE = "ADD_SHARE";
const REMOVE_SHARE = "REMOVE_SHARE";
const SHARES_REQUEST = "SHARES_REQUEST";
const SHARES_SUCCESS = "SHARES_FETCH";
const SHARES_FAILURE = "SHARES_FAILURE";
const SHARES_UPDATE_REQUEST = "SHARES_UPDATE_REQUEST";
const SHARES_UPDATE_SUCCESS = "SHARES_UPDATE_SUCCESS";

export type SharesDialogState = {
    filter: string;
    isFetching: boolean;
    isUpdating: boolean;
    isFinished: boolean;
    shares: OrderedSet<string>;
    error?: object;
};

type Event = { type: string; payload: any };
type FetchEvent = { type: string; data?: any; error?: { message: string } };

export const setFilter = createAction(SET_FILTER);
export const addShare = createAction(ADD_SHARE);
export const removeShare = createAction(REMOVE_SHARE);

export const fetchRepShares = (catalogId: string) => (dispatch: (x: any) => void) =>
    dispatch({
        [CALL_API]: {
            method: "GET",
            endpoint: `/api/v3.0/catalog/${catalogId}/shares`,
            types: [SHARES_REQUEST, SHARES_SUCCESS, SHARES_FAILURE],
        },
    });

export const updateRepShares =
    (catalogId: string) => (dispatch: (x: any) => void, getState: () => { catalogShares: SharesDialogState }) =>
        dispatch({
            [CALL_API]: {
                method: "PUT",
                endpoint: `/api/v3.0/catalog/${catalogId}/shares`,
                types: [SHARES_UPDATE_REQUEST, SHARES_UPDATE_SUCCESS, SHARES_FAILURE],
                body: { account_ids: getState().catalogShares.shares.toArray() },
            },
        });

const initialState: SharesDialogState = {
    filter: "",
    isFetching: false,
    isUpdating: false,
    isFinished: false,
    shares: OrderedSet(),
};

export default handleActions(
    {
        [SET_FILTER]: (state: SharesDialogState, event: Event): SharesDialogState => ({
            ...state,
            filter: event.payload,
        }),

        [ADD_SHARE]: (state: SharesDialogState, event: Event): object => ({
            ...state,
            filter: "",
            shares: state.shares.add(event.payload),
        }),

        [REMOVE_SHARE]: (state: SharesDialogState, event: Event): SharesDialogState => ({
            ...state,
            shares: state.shares.remove(event.payload),
        }),

        [SHARES_REQUEST]: (state: SharesDialogState): SharesDialogState => ({
            ...state,
            isFinished: false,
            isFetching: true,
            filter: "",
            shares: OrderedSet(),
        }),

        [SHARES_SUCCESS]: (state: SharesDialogState, event: FetchEvent): SharesDialogState => ({
            ...state,
            isFetching: false,
            isUpdating: false,
            shares: OrderedSet(event.data),
        }),

        [SHARES_FAILURE]: (state: SharesDialogState, event: FetchEvent): SharesDialogState => ({
            ...state,
            isFetching: false,
            isUpdating: false,
            error: event.error,
        }),

        [SHARES_UPDATE_REQUEST]: (state: SharesDialogState): SharesDialogState => ({
            ...state,
            isUpdating: true,
        }),

        [SHARES_UPDATE_SUCCESS]: (state: SharesDialogState): SharesDialogState => ({
            ...state,
            isFinished: true,
            isUpdating: false,
        }),
    } as any,
    initialState,
);
